import {
  fieldValidators as unifiedFieldValidators,
  validateField as unifiedValidateField,
  FieldValidationResult,
  FieldValidator,
  type ValidateFieldOptions,
} from '@account/utils/fieldValidators'
import { RegistrationFormData } from './_reducer'

/**
 * Re-export unified field validators for backward compatibility.
 * This file now acts as a facade to the unified validation system.
 */
export type { FieldValidationResult, FieldValidator, ValidateFieldOptions }

export const fieldValidators = unifiedFieldValidators

/**
 * Validate a single field against the unified validation rules.
 * Wrapper for backward compatibility with existing Registration code.
 */
export const validateField = (
  fieldName: string,
  value: any,
  formData: RegistrationFormData,
  options?: ValidateFieldOptions
): FieldValidationResult => unifiedValidateField(fieldName, value, formData, options)
